const loadingLabel = "Lade";
const deDE = {
  loadingLabel
};
export {
  deDE as default,
  loadingLabel
};
